// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
//const merge = require('lodash/object/merge');
const Immutable = require('immutable');

// @commons
const i18nCommons = require('commonsUtilities/i18n').i18n;
import { FormattedText } from 'commonsComponents/formattedText';

// @constants
const { PRODUCTION_ENVIRONMENT } = require('constants/index');
//const { DEFAULT_TRANSLATION_TEXT } = require('commonsConstants/i18n');
const { ES_LANG } = require('constants/contactCenter/language');
const isProduction = __ENVIRONMENT__ === PRODUCTION_ENVIRONMENT;

// @core
const { getStore } = require('core/storeHelper');

// Update store if it does not exist and check if its valid
let store = null;
const validStore = () => {
    if (!store) store = getStore();
    return !!(typeof store !== 'undefined' && store);
}

// NOTE: This should be removed when traslations is erased from package
// If the translation call has not yet been fetched we consume the strings from node_modules
const getStrings = () => {
    if (validStore()) {
        return store.getState().translations;
    } else {
        // In other case we use directly the translations from node_modules
        // (This is the case of all the requires defined directly in files in constants, utilities and reducers)
        return Immutable.fromJS({translations: {}});
    }
};

// Gets the selected language
const getLanguage = () => i18nCommons.getLanguage(false, ES_LANG);
const i18nLanguage = getLanguage();

const isDefaultLanguage = () => i18nCommons.isDefaultLanguage();

// Checks if a string code has a translation (including cc translations)
const hasTranslation = stringCode => {
    // NOTE: Commented until traslations is removed from package
    // return validStore() ? i18nCommons.hasTranslation(__CONTACT_CENTER__, store.getState().translations, stringCode) : false;
    
    return i18nCommons.hasTranslation(__CONTACT_CENTER__, getStrings(), stringCode);
};

// Returns the translation of the string code (including cc translations)
const formatText = (stringCode, injectedStrings, useLanguage, originCountry=undefined) => {
    // NOTE: Commented until traslations is removed from package
    // return validStore() ? i18nCommons.formatText(__CONTACT_CENTER__, store.getState().translations, isProduction, stringCode, injectedStrings, useLanguage, originCountry) : DEFAULT_TRANSLATION_TEXT;
    
    return i18nCommons.formatText(__CONTACT_CENTER__, getStrings(), isProduction, stringCode, injectedStrings, useLanguage, originCountry);
};

const getFinalTitle = (titleKey, titleStrings = []) => {
    if (!!titleKey) {
        if (typeof(titleKey) === 'string') {
            if (hasTranslation(titleKey)) {
                return <FormattedTextConnected value={titleKey} injectedStrings={titleStrings} />;
            }
        }
        return titleKey
    }
    return null;
};

const formatTextApi = (stringCode, stringValue, injectedStrings, useLanguage, originCountry=undefined) => {
    // NOTE: Commented until traslations is removed from package
    // return validStore() ? i18nCommons.formatTextApi(__CONTACT_CENTER__, store.getState().translations, isProduction, stringCode, stringValue, injectedStrings, useLanguage, originCountry) : DEFAULT_TRANSLATION_TEXT;
    
    return i18nCommons.formatTextApi(__CONTACT_CENTER__, getStrings(), isProduction, stringCode, stringValue, injectedStrings, useLanguage, originCountry);
};

const formatTextWithDefaultMessage = (stringCode, injectedStrings, useLanguage, defaultMessageCode, defaultInjectedStrings, originCountry=undefined) => {
    // NOTE: Commented until traslations is removed from package
    // return validStore() ? i18nCommons.formatTextWithDefaultMessage(__CONTACT_CENTER__, store.getState().translations, isProduction, stringCode, injectedStrings, useLanguage, defaultMessageCode, defaultInjectedStrings, originCountry) : DEFAULT_TRANSLATION_TEXT;
    
    return i18nCommons.formatTextWithDefaultMessage(__CONTACT_CENTER__, getStrings(), isProduction, stringCode, injectedStrings, useLanguage, defaultMessageCode, defaultInjectedStrings, originCountry);
};

const getFormattedLanguage = (language) => i18nCommons.getFormattedLanguage(__CONTACT_CENTER__, language);

class FormattedTextCommons extends React.Component {
    render() {        
        const { translations, language } = this.props;
        const useLanguage = language || i18nLanguage;
        const translationsStrings = getStrings();
        const hasBeenFetchedPRI = translations.get('hasBeenFetchedPRI');
        const hasBeenFetchedCC = translations.get('hasBeenFetchedCC');
        const errorPRI = translations.get('errorPRI');
        const errorCC = translations.get('errorCC');
        const notReady = !hasBeenFetchedPRI || errorPRI || (__CONTACT_CENTER__ && (!hasBeenFetchedCC && errorCC));

        // Wait for both translations
        if (notReady) return null;
        
        return (
            <FormattedText
                {...this.props}
                translations={translationsStrings}
                isProduction={isProduction}
                isContactCenter={__CONTACT_CENTER__}
                language={useLanguage}
            />
        );
    }
}

FormattedTextCommons.propTypes = {
    immVariables: PropTypes.any,
    originCountry: PropTypes.string,
    translations: PropTypes.object,
    className: PropTypes.string,
    defaultInjectedStrings: PropTypes.array,
    defaultMessageCode: PropTypes.string,
    format: PropTypes.string,
    id: PropTypes.string,
    injectedStrings: PropTypes.array,
    language: PropTypes.string,
    value: PropTypes.string,
    noWrapper: PropTypes.bool,
    apiValue: PropTypes.string,
    withCountrySuffix: PropTypes.bool
};

const FormattedTextConnected = connect(
    state => ({
        immVariables: state.globalVariables.get('variables'),
        originCountry: state.profile.get('originCountry'),
        translations: state.translations,
    })
)(FormattedTextCommons);

module.exports.i18n = {
    getLanguage,
    isDefaultLanguage,
    hasTranslation,
    formatText,
    getFinalTitle,
    formatTextApi,
    formatTextWithDefaultMessage,
    getFormattedLanguage,
    FormattedText: FormattedTextConnected,
};